import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { selectDataByKey } from 'src/storage/general.selectors';

type ProductsConfigurationData = {
  Property?: unknown;
  Tenant?: unknown;
  PolicyHolder?: unknown;
  ProductCode?: unknown;
};

function hasAnyValue(obj: unknown): boolean {
  if (obj === null || obj === undefined) return false;
  if (typeof obj !== 'object') return true;
  if (Array.isArray(obj)) return obj.length > 0;

  return Object.values(obj as Record<string, unknown>).some(v => hasAnyValue(v));
}

export type NewFlowSessionValidationResult = {
  ok: boolean;
  sessionId: number;
  hasProductsConfigurationData: boolean;
};

/**
 * Valida si existe el contexto mínimo para ejecutar pantallas del flujo (new-flow):
 * - session_id en localStorage
 * - productsConfigurationData en el store con algún valor
 */
export async function validateNewFlowSessionContext(
  store: Store
): Promise<NewFlowSessionValidationResult> {
  const sessionId = Number(localStorage.getItem('session_id')) || 0;
  const productsConfigurationData = await firstValueFrom(
    store.select(selectDataByKey('Property'))
  );

  const hasProductsConfigurationData = hasAnyValue(productsConfigurationData as ProductsConfigurationData);

  return {
    ok: sessionId > 0 && hasProductsConfigurationData,
    sessionId,
    hasProductsConfigurationData,
  };
}

/**
 * Helper para usar en ngOnInit: si no hay contexto mínimo, redirecciona al inicio del cotizador
 * y retorna false. Si está OK, retorna true.
 */
export async function ensureNewFlowSessionContextOrRedirect(
  store: Store,
  router: Router
): Promise<boolean> {
  const result = await validateNewFlowSessionContext(store);

  if (result.ok) return true;

  // Limpieza preventiva para evitar que quede un estado inconsistente
  localStorage.removeItem('state_service');

  await router.navigate(['seguros/hogar/arriendo/cotizador']);
  return false;
}
